// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"663":"b0f0dfb4e50f2dd5","1337":"4f9696d966b11cea","1522":"07dcdf78768b840d","1661":"d820c4c4aeeff767","2623":"1917d8cff0ba55a3","9964":"401db8dc0b38ebe1"}[chunkId] + ".js";
};